import React from 'react'
import BulkUploadExpenseLabels from 'src/components/BulkUploadExpenseLabels/BulkUploadExpenseLabels'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { bulkUploadExpenseLabelsRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const BulkUploadExpenseLabelsAppRoute: AppRoute = {
  id: AppLocation.BulkUploadExpenseLabels,
  routeProps: bulkUploadExpenseLabelsRouteProps,
  component: <BulkUploadExpenseLabels />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default BulkUploadExpenseLabelsAppRoute
